import React, { useState } from "react";
import { Dropdown, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label } from "reactstrap";
import { DropdownForms, SignIn } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";

export const DropdownForm = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <div className="btn-group">
      <Dropdown isOpen={open} toggle={toggle}>
        <DropdownToggle caret color="secondary" className="text-white">{DropdownForms}</DropdownToggle>
        <DropdownMenu className="p-4 form-wrapper dark-form">
          <Form>
            <FormGroup className="mb-3">
              <Label>Email address</Label>
              <Input type="email" placeholder="email@example.com" required />
            </FormGroup>
            <FormGroup className="mb-3">
              <Label>Password</Label>
              <Input type="password" autoComplete="" placeholder="Password" />
            </FormGroup>
            <FormGroup className="mb-3">
              <FormGroup className="form-check">
                <Input type="checkbox" />
                <Label>Remember me</Label>
              </FormGroup>
            </FormGroup>
            <Btn color="dark">{SignIn}</Btn>
          </Form>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
